import React, { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { GetProductCategoryListDropDownSlice } from "../../../redux/features/ProductCategorySlice";
import { AddMetaDataSlice } from "../../../redux/features/MetaDataManagementSlice";
import Editor from "../../../common/Editor/Editor";

const AddMetaCategory = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [categoryList, setCategoryList] = useState([]);
  const [form, setForm] = useState({
    type: "",
    categoryId: "",
    subcategoryId: "",
    title: "",
    description: "",
    keywords: "",
    content: "",
    status: "active",
  });

  /* 🔹 Fetch category dropdown list */
  useEffect(() => {
    dispatch(GetProductCategoryListDropDownSlice()).then((res) => {
      setCategoryList(res?.payload?.data || []);
    });
  }, [dispatch]);

  /* 🔹 Handle simple input changes */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  /* 🔹 Handle editor content */
  const handleEditorChange = (updatedContent) => {
    setForm((prev) => ({ ...prev, content: updatedContent }));
  };

  /* 🔹 Submit form */
  const handleSubmit = () => {

    dispatch(AddMetaDataSlice(form))
      .then((res) => {
        if (res?.payload?.status) {
          setForm({
            type: "",
            categoryId: "",
            subcategoryId: "",
            title: "",
            description: "",
            keywords: "",
            content: ""
          });

          // ✅ REDIRECT TO TABLE PAGE
        navigate("/MetaDataManagement/CategoryMetaData");
  
        } else {
          alert("Failed to add Meta Category");
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Something went wrong!");
      });
  };

  const typeOptions = [
    { label: "Category", value: "CATEGORY" }
  ];

  return (
    <div className="Small-Wrapper mt-4">
      {/* Category Dropdown */}
      <div className="form-group">
        <label>Category</label>
        <select
          name="categoryId"
          className="form-control"
          value={form.categoryId}
          onChange={handleChange}
        >
          <option value="">Select Category</option>
          {categoryList.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.categoryName}
            </option>
          ))}
        </select>
      </div>


      {/* TYPE */}
      <div className="form-group">
        <label>Type</label>
        <select
          className="form-control"
          name="type"
          value={form.type}
          onChange={handleChange}
        >
          <option value="">-- Select Type --</option>
          {typeOptions.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </div>

      {/* Title */}
      <div className="form-group">
        <label>Title</label>
        <input
          type="text"
          name="title"
          className="form-control"
          value={form.title}
          onChange={handleChange}
        />
      </div>

      {/* Description */}
      <div className="form-group">
        <label>Description</label>
        <textarea
          name="description"
          className="form-control"
          value={form.description}
          onChange={handleChange}
        />
      </div>

      {/* Keywords */}
      <div className="form-group">
        <label>Keywords</label>
        <input
          type="text"
          name="keywords"
          className="form-control"
          value={form.keywords}
          onChange={handleChange}
        />
      </div>

      {/* Content */}
      <div className="form-group">
        <label>Content</label>
        <Editor
          setContentState={setForm}
          type="content"
           content={form.content}
          form={form}
        />
      </div>
      <button className="Button mt-3" onClick={handleSubmit}>
        Add
      </button>
    </div>
  );
};

export default AddMetaCategory;
